import React from 'react';
import ReactDOM from 'react-dom';

import 'semantic-ui-css/semantic.min.css';
import './index.css';

import App from './App';
import { BrowserRouter } from 'react-router-dom';

const target = document.getElementById('root');
const Component = () => (
  <BrowserRouter basename='/ads-preview'>
    <App />
  </BrowserRouter>
);

ReactDOM.render((
  <Component/>
), target);

if (module.hot) {
  module.hot.accept('./App', () => {
    ReactDOM.render((
      <Component/>
    ), target);
  });
}

